define([
    '../Util/freezeObject'
], function (
    freezeObject) {
    'use strict'

    /**
     * 渲染模式。
     *
     * @exports EnumRenderMode
     * 
     * @see GeoCuboid#renderMode
     */
    var EnumRenderMode = {
        /**
         * 颜色、深度均绘制。
         * @type {Number}
         * @constant
         */
        NORMAL: 0,

        /**
         * 仅渲染深度，常用于透明蒙版。
         * @type {Number}
         * @constant
         */
        DEPTH: 1,

        /**
         * 颜色、深度均不绘制，用于拾取。
         * @type {Number}
         * @constant
         */
        NULL: 2
    }
    freezeObject(EnumRenderMode)
    /**
     * 反向查找对齐方式的名称。
     * 
     * @param {Number} value 对齐方式的数值。
     * @returns {String} 对齐方式的名称。
     */
    function getName(value) {
        for (var key in EnumRenderMode) {
            if (EnumRenderMode.hasOwnProperty(key) && EnumRenderMode[key] === value) {
                return key
            }
        }
        return undefined
    }
    return {
        NORMAL: 0,
        DEPTH: 1,
        NULL: 2,
        getName: getName
    }
})